import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import RankName from '../RankName';
import CountUp from '../CountUp';
import { useT } from '../../i18n/LanguageContext';

/**
 * Folie 33 — Rang Bonus.
 * Same layout DNA as Worldpools: 9 ascending rank cards (Emerald → Black
 * Diamond) with the original PPTX coin, rank name and one-time bonus value.
 * Ascending light→dark tint reused from the World Pools palette.
 */
export default function SectionRangBonus() {
  const { t } = useT();
  const m = t.rangBonus;
  // Presenter feedback: remove Emerald — start the ranks list from Diamond onwards.
  const ranks = (m.ranks || []).filter((r) => r.name !== 'Emerald');

  return (
    <SectionShell id="rang-bonus" className="">
      <div className="grid grid-cols-12 gap-y-8 md:gap-12 mb-12 items-start">
        <div className="col-span-12 md:col-span-9">
          <Reveal>
            <div className="overline mb-6">{m.overline}</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-white max-w-[16ch] mb-6">
              {m.title}
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <div className="space-y-4 text-white/85 font-ui text-4xl md:text-5xl lg:text-[3.4rem] leading-tight max-w-[80ch]">
              {m.sub.split(/(?<=\.)\s+/).filter(Boolean).map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      {/* Rank cards (Emerald removed) */}
      <Reveal delay={200}>
        <div className="rb-matrix-scroll">
          <div className="rb-matrix" data-testid="rb-matrix">
            {ranks.map((r, idx) => (
              <div
                key={r.name}
                className="wp-rank-card rb-rank-card"
                data-testid={`rb-rank-${idx}`}
                style={{ '--step': idx }}
              >
                <div className="wp-coin">
                  <img
                    src={`/source-pptx/${r.coin}`}
                    alt={`${r.name} Rang`}
                    loading="lazy"
                    draggable={false}
                    className="block w-full h-full object-contain select-none"
                    style={{ filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.6))' }}
                  />
                </div>
                <div className="wp-rank-name font-display"><RankName name={r.name} /></div>
                <div className="rb-value font-display">{r.value || '\u00A0'}</div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>

      {/* Big total */}
      <Reveal delay={720}>
        <div className="unilevel-total mt-12" data-testid="rb-total">
          <span className="unilevel-total-line" aria-hidden />
          <div className="unilevel-total-block rb-total-block">
            <span className="unilevel-total-big font-display">{m.highlight}</span>
            <span className="rb-total-huge font-display"><CountUp value={m.totalValue} /></span>
          </div>
          <span className="unilevel-total-line" aria-hidden />
        </div>
      </Reveal>
    </SectionShell>
  );
}
